import { BoxProps, ColorOptions } from '@jfs/ui-new'
import { Colors } from '../../utils'
const shadowStyle = {
  shadowOffset: { width: 1, height: 1 },
  shadowRadius: 3,
  shadowColor: '#0000001F',
  borderRadius: 8,
  borderWidth: 1,
  borderColor: '#00000014',
  zIndex: 10,
}

const styles = () => {
  return {
    container: {
      ...shadowStyle,
      marginHorizontal: 16,
      paddingHorizontal: 16,
      borderRadius: 8,
      flex: 1,
      overflowY: 'auto',
      nativeID: 'showListScrollBar',
    } as BoxProps,
    emptyContainer: {
      alignContent: 'center',
      flex: 1,
    } as BoxProps,
    tableContainer: (isLoading: boolean) =>
      ({
        alignContent: 'center',
        flexGrow: 1,
        marginTop: isLoading ? 24 : undefined,
      } as BoxProps),
    modal: {
      position: 'absolute',
      elevation: 2,
      shadowOpacity: 1,
      opacity: 1,
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      ...shadowStyle,
      zIndex: 1,
      borderWidth: 1,
      borderColor: '#00000014',
    } as unknown as BoxProps,
    overlayStyle: {
      backgroundColor: Colors.OVERLAY as ColorOptions,
      width: '100%',
      height: '100%',
      // justifyContent: 'center',
    } as BoxProps,
    dropdownStyle: (xPos: number, yPos: number, right: number) =>
      ({
        position: 'absolute',
        flex: 1,
        shadowColor: '#000001',
        shadowOffset: {
          width: 0,
          height: 2,
        },
        shadowOpacity: 0.3,
        shadowRadius: 10,
        elevation: 2,
        borderRadius: 12,
        borderColor: '#E1E5E8',
        left: xPos,
        top: yPos + 10,
        right: right,
        alignSelf: 'center',
        marginTop: 15,
      } as unknown as BoxProps),
    mobileSelectionFix: {
      marginRight: 0,
      display: 'flex',
      borderWidth: 1,
      flexWrap: 'wrap',
      flexDirection: 'row',
      borderColor: 'TRANSPARENT',
    } as BoxProps,
  }
}

export { styles }
